<template>
  <div v-if="personData" class="mt-6 p-lg-6 p-3">
    <div v-if="personData.invitedMe.length">
      <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.invited_to_join_the_company") }}</h3>
      <div>
        <div
          v-for="(invite, index) in personData.invitedMe"
          :key="`invite_${index}`"
          class="card shadow-sm mt-2 p-3">
          <div class="row">
            <div class="col-md-9 ">
              <h4>{{ $t("common.welcome_screen.company") }} «{{invite.company.name}}»</h4> <span v-if="invite.is_admin" class="ml-3 badge badge-primary">{{ $t("common.welcome_screen.as_admin") }}</span>
            </div>
            <div class="col-md-3">
              <button @click="acceptInvite(invite._id)" class="btn btn-sm btn-primary float-right">{{ $t("common.welcome_screen.accept") }}</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9 ">
              <span class="small text-muted">{{ invite.created_at | moment("from")}} by {{invite.creator.first_name}} {{invite.creator.last_name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button @click="checkInvite(true)" class="btn btn-sm btn-light"><i class="fe fe-refresh-ccw mr-2"></i>{{ $t("common.welcome_screen.check_again") }}</button>
        <small class="text-muted ml-2">or</small>
        <button @click="emitStep('createCompany')" class="btn btn-sm text-secondary btn-link">{{ $t("common.welcome_screen.create_new_company") }}</button>
      </div>
    </div>
    <div v-else>
      <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.waiting_to_join_existing_company") }}</h3>
      <p>
        {{ $t("common.welcome_screen.ask_with_access_rights_to_invite_members_to_send_invitation") }} <b>{{email}}</b>
      </p>
      <div class="text-center">
        <button @click="checkInvite(true)" class="btn btn-sm btn-light"><i class="fe fe-refresh-ccw mr-2"></i>{{ $t("common.welcome_screen.check_invitations") }}</button>
        <small class="text-muted ml-2">or</small>
        <button @click="emitStep('createCompany')" class="btn btn-sm btn-link">{{ $t("common.welcome_screen.create_new_workspace") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  import { CheckInviteMixin } from '../mixins/CheckInviteMixin';

  import { acceptInvitation } from '../../../api/authApi';

  export default {
    name: 'JoinCompanyStep',
    mixins: [AuthStepsMixin, CheckInviteMixin],
    methods: {
      acceptInvite: async function (inviteId) {
        const { ok, error } = await acceptInvitation(inviteId);

        if (ok) {
          this.$noty.success('You just joined the company');
          await this.$store.dispatch('fetchAccount');
          if (this.$store.state.account.status === 'inactive' && !this.$store.state.account.email_confirmed) {
            this.emitStep('emailConfirmation');
          } else {
            setTimeout(() => {
              window.location.href = '/';
            }, 2000);
          }
        } else {
          this.$noty.error(error);
        }
      },
    },
  };
</script>

<style scoped>

</style>
